import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "lk-portal-login" }
const _hoisted_2 = { class: "lk-portal-login-container" }
const _hoisted_3 = { class: "lk-portal-login-content-title" }
const _hoisted_4 = {
  key: 0,
  class: "embed-logo"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "embed-wrapper" }
const _hoisted_7 = { class: "lk-portal-login-container" }
const _hoisted_8 = { class: "lk-portal-login-footer" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("©2019 ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "京ICP备20001360号-1", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("零氪科技提供技术支持 ©2020 LinkDoc ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "京ICP备15001843号-1", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginBox = _resolveComponent("LoginBox")!
  const _component_PrivateLogin = _resolveComponent("PrivateLogin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", {
      class: _normalizeClass({'lk-portal-login-content': true, 'henanbc': _ctx.state.isHenanBc})
    }, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.state.title), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.state.core), 1)
        ], 512), [
          [_vShow, !_ctx.state.isHenanBc]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass({'lk-portal-login-content-login-modal': true, 'henanbc': _ctx.state.isHenanBc})
        }, [
          (_ctx.showLinkdocText && !_ctx.state.isHenanBc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.state.logo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "logo",
                      src: _ctx.state.logo,
                      alt: "logo"
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'embed-passport-login': true, 'private-passport-login': _ctx.state.isInHospEnv && _ctx.isNuc }),
              id: "embed-passport-login"
            }, [
              (_ctx.state.isInHospEnv && _ctx.isNuc)
                ? (_openBlock(), _createBlock(_component_LoginBox, {
                    key: 0,
                    loginBoxOutStyle: false,
                    showForget: ""
                  }))
                : _createCommentVNode("", true),
              (_ctx.state.isInHospEnv && !_ctx.isNuc)
                ? (_openBlock(), _createBlock(_component_PrivateLogin, { key: 1 }))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ], 2), [
          [_vShow, _ctx.state.logo]
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("footer", _hoisted_8, [
        (_ctx.state.isInHospEnv)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, "在使用本产品的过程中请严格遵守医院的个人信息处理规则！"))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, _toDisplayString(_ctx.state.desc), 1),
        (_ctx.isNuwarwe())
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _hoisted_13))
          : (_ctx.showLinkdocText)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _hoisted_17))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
}